export const initDrop = function () {
  const navLink = document.querySelectorAll('[data-nav="link"]');
  const nav = document.querySelector('[data-nav="menu"]');
  const catalog = document.querySelector('[data-catalog="menu"]');
  const dropLink = document.querySelectorAll('[data-drop="link"]');
  const dropPrev = document.querySelectorAll('[data-drop="prev"]');
  const dropLinkCatalog = document.querySelector('[data-catalog="burger"]');
  const breakpointTablet = 768;
  const breakpointDesktop = 1500;

  if (navLink) {
    navLink.forEach((link) => {
      link.addEventListener('click', (evt) => {

        if (document.documentElement.clientWidth < breakpointDesktop) {
          evt.preventDefault();
          const elNext = link.nextElementSibling;
          if (elNext.classList.contains('is-active-drop')) {
            elNext.classList.remove('is-active-drop');
            if (link.classList.contains('is-active-link')) {
              link.classList.remove('is-active-link');
            }
          } else {
            const activeDrop = nav.querySelectorAll('.is-active-drop');
            if (activeDrop) {
              activeDrop.forEach(element => {
                element.classList.remove('is-active-drop');
                const linkEl = element.previousElementSibling;
                if (linkEl.classList.contains('is-active-link')) {
                  linkEl.classList.remove('is-active-link')
                }
              });
            }
            link.classList.add('is-active-link');
            elNext.classList.add('is-active-drop');
          }
        }

      })
    })
  }

  if (dropLink) {
    dropLink.forEach((item) => {
      item.addEventListener('click', (evt) => {
        const dropBlock = item.nextElementSibling;
        if (document.documentElement.clientWidth < breakpointTablet) {
          evt.preventDefault();
          if (!dropBlock.classList.contains('is-active-drop')) {
            dropBlock.classList.add('is-active-drop');
            item.classList.add('is-active-link');
          }
        }
        if (breakpointTablet <= document.documentElement.clientWidth && document.documentElement.clientWidth < breakpointDesktop) {
          evt.preventDefault();
          if (dropBlock.classList.contains('is-active-drop')) {
            dropBlock.classList.remove('is-active-drop');
            if (item.closest('.is-active-link')) {
              item.classList.remove('is-active-link');
            }
          } else {
            const activeCatalogDrop = catalog.querySelectorAll('.is-active-drop');
            if (activeCatalogDrop) {
              activeCatalogDrop.forEach(element => {
                element.classList.remove('is-active-drop');
                const linkEl = element.previousElementSibling;
                if (linkEl.classList.contains('is-active-link')) {
                  linkEl.classList.remove('is-active-link')
                }
              });
            }
            item.classList.add('is-active-link');
            dropBlock.classList.add('is-active-drop');
          };
        }
      })
    })
  }

  if (dropLinkCatalog) {
    dropLinkCatalog.addEventListener('click', (evt) => {
      evt.preventDefault();
      if (breakpointTablet > window.innerWidth) {
        const dropBlockCatalog = dropLinkCatalog.nextElementSibling;
        if (dropBlockCatalog.classList.contains('is-active-drop')) {
          dropBlockCatalog.classList.remove('is-active-drop');
        } else {
          dropBlockCatalog.classList.add('is-active-drop');
        }
      }
    })
  }


  if (dropPrev) {
    dropPrev.forEach((item) => {
      item.addEventListener('click', (evt) => {
        evt.preventDefault();
        const dropParents = item.closest('.is-active-drop');
        if (dropParents) {
          dropParents.classList.remove('is-active-drop')
        }
      })
    })
  }
}
